const ERRORS = {
  enter_area_msg: 'Bitte Fläche angeben',
};

export default ERRORS;
